import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ucFirst } from '../../utils/caseconverters';

import styles from './Icon.module.scss';

import ArrowThin from './icons/arrow-thin';
import Arrow from './icons/arrow';
import BreadcrumbChevron from './icons/breadcrumb-chevron';
import Check from './icons/check';
import ChevronThin from './icons/chevron-thin';
import ChevronThinLarge from './icons/chevron-thin-large';
import Chevron from './icons/chevron';
import Cross from './icons/cross';
import CrossSmall from './icons/cross-small';
import Download from './icons/download';
import DownloadSmall from './icons/download-small';
import External from './icons/external';
import Filter from './icons/filter';
import Hamburger from './icons/hamburger';
import Info from './icons/info';
import Link from './icons/link';
import Minus from './icons/minus';
import NordRedBoxLarge from './icons/nord-red-box-2';
import NordRedBoxMedium from './icons/nord-red-box-3';
import NordRedBoxSmall from './icons/nord-red-box-4';
import Pause from './icons/pause';
import Pin from './icons/pin';
import Play from './icons/play';
import Plus from './icons/plus';
import Search from './icons/search';
import SearchSmall from './icons/search-small';
import Share from './icons/share';
import Facebook from './icons/facebook';
import Instagram from './icons/instagram';
import Twitter from './icons/twitter';
import TwitterX from './icons/twitterx';
import Youtube from './icons/youtube';
import Linkedin from './icons/linked-in';
import MagnifyingGlass from './icons/magnifying-glas';
import MagnifyingGlassWhite from './icons/magnifying-glas-white';
import CheckGreen from './icons/check-green';
import CrossRed from './icons/cross-red';
import AlertInfo from './icons/alert-info';
import AlertWarning from './icons/alert-warning';
import AlertTip from './icons/alert-tip';
import ChevronThinRight from './icons/chevron-thin-right';
import ChevronThinLeftWhite from './icons/chevron-thin-left-white';
import NordWordmarkWhite from './icons/nord-wordmark-white';
import ManualAppendix from './icons/manual-appendix';
import ManualConnection from './icons/manual-connection';
import ManualEffects from './icons/manual-effects';
import ManualGettingStarted from './icons/manual-getting-started';
import ManualIntro from './icons/manual-intro';
import ManualMenu from './icons/manual-menu';
import ManualMidi from './icons/manual-midi';
import ManualOrgan from './icons/manual-organ';
import ManualOverview from './icons/manual-overview';
import ManualPiano from './icons/manual-piano';
import ManualProgram from './icons/manual-program';
import ManualSoftware from './icons/manual-software';
import ManualSynth from './icons/manual-synth';

export const allIcons = {
    breadcrumbChevron: BreadcrumbChevron,
    arrowThin: ArrowThin,
    arrow: Arrow,
    check: Check,
    chevronThin: ChevronThin,
    chevronThinLarge: ChevronThinLarge,
    chevron: Chevron,
    cross: Cross,
    crossSmall: CrossSmall,
    download: Download,
    downloadSmall: DownloadSmall,
    external: External,
    filter: Filter,
    hamburger: Hamburger,
    info: Info,
    link: Link,
    minus: Minus,
    nordRedBoxLarge: NordRedBoxLarge,
    nordRedBoxMedium: NordRedBoxMedium,
    nordRedBoxSmall: NordRedBoxSmall,
    pause: Pause,
    pin: Pin,
    play: Play,
    plus: Plus,
    search: Search,
    searchSmall: SearchSmall,
    share: Share,
    facebook: Facebook,
    instagram: Instagram,
    twitter: Twitter,
    twitterx: TwitterX,
    youtube: Youtube,
    linkedin: Linkedin,
    magnifyingGlass: MagnifyingGlass,
    magnifyingGlassWhite: MagnifyingGlassWhite,
    checkGreen: CheckGreen,
    crossRed: CrossRed,
    alertInfo: AlertInfo,
    alertWarning: AlertWarning,
    alertTip: AlertTip,
    chevronThinRight: ChevronThinRight,
    chevronThinLeftWhite: ChevronThinLeftWhite,
    nordWordmarkWhite: NordWordmarkWhite,
    manualAppendix: ManualAppendix,
    manualConnection: ManualConnection,
    manualEffects: ManualEffects,
    manualGettingStarted: ManualGettingStarted,
    manualIntro: ManualIntro,
    manualMenu: ManualMenu,
    manualMidi: ManualMidi,
    manualOrgan: ManualOrgan,
    manualOverview: ManualOverview,
    manualPiano: ManualPiano,
    manualProgram: ManualProgram,
    manualSoftware: ManualSoftware,
    manualSynth: ManualSynth,
};

const Icon = ({ type = '', size = '', modifiers = [], dimensions = {}, srText = '' }) => {
    const Svg = allIcons[type];

    return (
        <span
            className={classNames(
                styles['Icon'],
                styles['Icon--' + ucFirst(type)],
                styles['Icon--' + ucFirst(size)],
                modifiers.map(
                    (modifier) => styles['Icon--' + ucFirst(modifier)]
                )
            )}
            style={
                dimensions
                    ? {
                        width: dimensions.width,
                        height: dimensions.height,
                    }
                    : ''
            }
        >
            {!!Svg && <Svg />}
        </span>
    );
};

Icon.propTypes = {
    type: PropTypes.oneOf(Object.keys(allIcons)),
    size: PropTypes.oneOf([
        '',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'xxlarge',
        'xxxlarge',
        'xxxxlarge',
    ]),
    modifiers: PropTypes.array,
    dimensions: PropTypes.shape({
        width: PropTypes.string,
        height: PropTypes.string,
    }),
    srText: PropTypes.string,
};

export default Icon;
